<template>
  <div class="fccPublicacoes">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage titlePage="Banners de Concursos" />
      <div class="row" v-for="categoria in tipoBanners" :key="categoria">
        <div class="col-sm-12 m-3">
          <div class="titlePage">{{ categoria }}</div>
          <fcc-galeria
            class="mt-3"
            cod-arq-cad="CDN"
            :extArqPermitido="['jpeg', 'jpg', 'png']"
            :id-externo="categoria + '_banners_concurso'"
            exibe-imagens
            tipo="arquivos"
            :tabelaMostra="false"
            :arqMaxQtde="20"
          ></fcc-galeria>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  data() {
    return {
      tipoBanners: ['Próximos Concursos'],
      tipoBanners2: ['Próximos Concursos', 'Em Andamento', 'Encerrados']
    }
  },
  methods: {}
}
</script>
  